<template>
  <ContactUsModal ref="OpenContactUsModal" />
  <v-container fluid class="container-main">
    <v-container fluid class="pa-0">
      <v-row justify="center">
        <v-col cols="12" md="11">
          <v-row justify="center" class="mt-15 mx-sm-0">
            <v-col order="1" order-md="2" cols="12" sm="12" md="6" align-self="center">
              <v-card-title v-if="$vuetify.display.xs" class="card-title-text fontRaleway px-0 my-4">
                {{ t(`$vuetify.service.limousine_services.right_block.title`) }}
              </v-card-title>
              <v-row>
                <v-col cols="6">
                  <v-card flat color="transparent" height="100%" class="card-service pa-3">
                    <v-row style="height: 100%;">
                      <v-col cols="12" align-self="center">
                        <v-card-text class="pb-0">
                          <span class="vip_service_1">
                            {{ t("$vuetify.service.limousine_services.left_block.vip_service.part1") }}
                          </span>
                          <span class="vip_service_2 fontRaleway ml-1">
                            {{ t("$vuetify.service.limousine_services.left_block.vip_service.part2") }}
                          </span>
                        </v-card-text>
                        <v-card-text class="vip_subtext fontSFProR">
                          {{ t("$vuetify.service.limousine_services.left_block.text") }}
                        </v-card-text>
                      </v-col>
                    </v-row>
                  </v-card>
                </v-col>
                <v-col cols="6">
                  <v-img width="100%" height="100%" cover class="discover-img"
                    src="../../assets/img/Service/limousine.jpg" lazy-src="../../assets/img/Service/lazy/limousine.jpg"
                    alt="Mercedes s-class executive car"></v-img>
                </v-col>
              </v-row>
            </v-col>
            <v-col order="2" order-md="1" cols="12" sm="12" md="6" align-self="center">
              <v-card class="px-lg-4" flat color="transparent">
                <v-card-title v-if="$vuetify.display.smAndUp" class="card-title-text fontRaleway px-0 mt-4">
                  {{ t(`$vuetify.service.limousine_services.right_block.title`) }}
                </v-card-title>
                <v-row>
                  <v-col cols="12" lg="10">
                    <v-tabs v-model="tab" :items="tabs" grow color="white" height="60" slider-color="#EEAC47"
                      class="mt-6">
                      <template v-slot:tab="{ item }">
                        <v-tab :value="item.value" color="#E6E8EB" base-color="#737475" class="tab-title fontSFProR">
                          {{ t(`$vuetify.service.limousine_services.right_block.items[${item.text}].title`) }}
                        </v-tab>
                      </template>

                      <template v-slot:item="{ item }">
                        <v-tabs-window-item :value="item.value" class="tabs-text fontSFProR pt-6">
                          <div>{{ t(`$vuetify.service.limousine_services.right_block.items[${item.text}].text`) }}</div>

                        </v-tabs-window-item>
                      </template>
                    </v-tabs>
                    <v-btn @click="OpenModal()" :block="$vuetify.display.xs ? true : false" variant="flat"
                      class="mt-6 px-4 fontSFProR card-btn" color="#DEE4EE">
                      <template v-slot:prepend>
                        <v-icon>
                          <svg width="18" height="19" viewBox="0 0 18 19" fill="none"
                            xmlns="http://www.w3.org/2000/svg">
                            <path
                              d="M2.99898 4.22222C2.99898 3.10242 3.47312 2.02848 4.31709 1.23666C5.16106 0.44484 6.30573 0 7.49928 0C8.69284 0 9.83751 0.44484 10.6815 1.23666C11.5255 2.02848 11.9996 3.10242 11.9996 4.22222C11.9996 4.40886 11.9206 4.58785 11.7799 4.71982C11.6392 4.85179 11.4485 4.92593 11.2495 4.92593C11.0506 4.92593 10.8598 4.85179 10.7192 4.71982C10.5785 4.58785 10.4995 4.40886 10.4995 4.22222C10.4995 3.47569 10.1834 2.75973 9.62075 2.23185C9.0581 1.70397 8.29499 1.40741 7.49928 1.40741C6.70358 1.40741 5.94047 1.70397 5.37782 2.23185C4.81517 2.75973 4.49908 3.47569 4.49908 4.22222C4.49908 4.40886 4.42006 4.58785 4.27939 4.71982C4.13873 4.85179 3.94795 4.92593 3.74903 4.92593C3.5501 4.92593 3.35932 4.85179 3.21866 4.71982C3.078 4.58785 2.99898 4.40886 2.99898 4.22222ZM16.4277 9.14815C15.6205 9.18333 14.9998 9.83602 14.9998 10.5934V11.2338C15.0024 11.4154 14.9316 11.5912 14.8017 11.7258C14.6718 11.8604 14.4923 11.9439 14.2994 11.9594C14.1968 11.9658 14.0939 11.9524 13.9971 11.9199C13.9003 11.8874 13.8116 11.8366 13.7366 11.7706C13.6616 11.7046 13.6019 11.6248 13.5611 11.5363C13.5204 11.4477 13.4995 11.3522 13.4997 11.2557V9.18773C13.4997 8.43037 12.879 7.78032 12.0718 7.7425C11.869 7.73333 11.6663 7.76289 11.476 7.82939C11.2857 7.8959 11.1118 7.99795 10.9647 8.12938C10.8177 8.26081 10.7007 8.41887 10.6207 8.59399C10.5408 8.7691 10.4995 8.95763 10.4995 9.14815V10.5318C10.5021 10.7134 10.4313 10.8892 10.3014 11.0238C10.1714 11.1585 9.992 11.242 9.79913 11.2575C9.69653 11.2639 9.59363 11.2504 9.49681 11.2179C9.4 11.1854 9.31134 11.1346 9.23634 11.0686C9.16134 11.0026 9.1016 10.9229 9.06084 10.8343C9.02008 10.7457 8.99916 10.6503 8.99939 10.5538V4.26181C8.99939 3.50444 8.37872 2.8544 7.57148 2.81657C7.36865 2.80741 7.16595 2.83697 6.97566 2.90347C6.78537 2.96997 6.61145 3.07203 6.46444 3.20345C6.31743 3.33488 6.20039 3.49294 6.12042 3.66806C6.04045 3.84318 5.9992 4.03171 5.99918 4.22222V14.7549C6.00146 14.9251 5.93944 15.0905 5.82412 15.2219C5.70879 15.3533 5.54761 15.4421 5.36914 15.4727H5.35789C5.24601 15.4845 5.13291 15.4649 5.03282 15.4166C4.93273 15.3682 4.85011 15.2932 4.79535 15.2009L2.82647 11.9955C2.42331 11.3393 1.53825 11.0657 0.820079 11.4132C0.638603 11.4998 0.477814 11.6201 0.347505 11.7669C0.217195 11.9137 0.120094 12.0838 0.062114 12.2669C0.00413414 12.45 -0.0135106 12.6423 0.0102548 12.832C0.0340202 13.0217 0.0986982 13.2049 0.200349 13.3704L3.1068 18.6525C3.17259 18.7577 3.26637 18.845 3.37896 18.9059C3.49155 18.9668 3.61907 18.9993 3.74903 19H16.4999C16.6392 19.0001 16.7759 18.9638 16.8944 18.8951C17.013 18.8264 17.1088 18.7281 17.1712 18.6112C17.2049 18.5479 18 17.2865 18 15.0355V10.5556C18.0002 10.3649 17.9592 10.1762 17.8793 10.0008C17.7995 9.82552 17.6825 9.66725 17.5354 9.53563C17.3884 9.40402 17.2144 9.30181 17.024 9.2352C16.8335 9.16859 16.6307 9.13897 16.4277 9.14815Z"
                              fill="#343330" />
                          </svg>
                        </v-icon>
                      </template>
                      <span class="ml-12">
                        {{ t(`$vuetify.service.limousine_services.right_block.items.topcars.btn_text`) }}
                      </span>
                    </v-btn>
                  </v-col>
                </v-row>
              </v-card>
            </v-col>
          </v-row>
        </v-col>
      </v-row>
    </v-container>
  </v-container>
</template>

<script>
import { useLocale } from "vuetify";
import ContactUsModal from "../Modals/ContactUsModal.vue";

export default {
  name: 'LimousineServices',
  setup() {
    const { t } = useLocale();
    return {
      t,
    };
  },
  components: {
    ContactUsModal
  },
  data: () => ({
    tab: 'tab-1',
    tabs: [
      {
        text: 'topcars',
        value: 'tab-1',
      },
      {
        text: 'chauffeurs',
        value: 'tab-2',
      },
      {
        text: 'pricing',
        value: 'tab-3',
      },
    ]
  }),
  methods: {
    OpenModal(item) {
      this.$refs.OpenContactUsModal.dialog = true;
      //this.$refs.OpenContactUsModal.property = card;
    },
  }
}
</script>

<style scoped>
.card-btn {
  justify-content: space-between;
  border-radius: 15px;
  box-shadow: unset;
  font-weight: 500;
  font-size: 1.05rem;
  text-transform: inherit;
  letter-spacing: 0.5px;
}

.tabs-text {
  color: #737475;
  font-size: 1.3rem;
}

.tab-title {
  text-transform: capitalize;
  font-size: 1.3rem;
  font-weight: 400;
  letter-spacing: 0.5px;
}

.card-service {
  border: 1px solid transparent;
  border-radius: 20px;
  background:
    linear-gradient(to bottom, #101010, #101010),
    linear-gradient(to bottom, #FE4F32, #030712);
  background-clip: padding-box, border-box;
  background-origin: padding-box, border-box;
}

.card-title-text {
  color: #E6E8EB;
  font-size: 2.7rem;
  font-weight: 300;
  white-space: normal;
  text-wrap: balance;
  letter-spacing: 4px;
  text-transform: uppercase;
}

.vip_service_1 {
  background: var(--GOLD-GLAZE, linear-gradient(158deg, #BD7810 29.54%, #FE4F32 78.34%));
  background-clip: text;
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
}

.vip_service_2 {
  color: #E6E8EB;
  font-size: .8rem;
  font-weight: 500;
}

.vip_subtext {
  color: #E6E8EB;
  font-size: 1.05rem;
  font-weight: 400;
}

.cards-btn {
  text-transform: inherit;
}

.cards-title-text {
  white-space: break-spaces;
  text-wrap: balance;
  color: #000000;
  font-size: 1.8rem;
  line-height: 2.2rem;
  min-height: 114px;
}

.cards-text {
  white-space: break-spaces;
  text-wrap: balance;
  color: #737475;
  font-size: 1rem;
  min-height: 220px;
}

.discover-img {
  border-radius: 15px;
}

.text-title {
  color: #E6E8EB;
  font-weight: 300;
  font-size: 5.5rem;
  line-height: 7rem;
  text-align: left;
  text-transform: uppercase;
}


.container-main {
  min-width: 100vw;
  background: #101010;
  padding-top: 10vh;
  padding-bottom: 10vh;
  position: relative;
  z-index: 1;
  margin-top: -1px;
}

@keyframes svg-anim {
  from {
    transform: rotate(-360deg);
  }

  to {
    transform: rotate(0deg);
  }
}

@media (min-width: 973px) and (max-width: 1300px) {
  .vip_subtext {
    font-size: .85rem;
  }

  .card-title-text {
    font-size: 2.5rem;
  }
}

@media (min-width: 600px) and (max-width: 960px) {
  .text-title {
    font-size: 3.8rem;
    font-weight: 300;
    line-height: 5rem;
  }

}

@media (max-width: 600px) {
  .text-title {
    font-size: 2.1rem;
    font-weight: 400;
    line-height: 3rem;
  }

  .vip_subtext {
    color: #E6E8EB;
    font-size: 0.7rem;
  }

  .card-title-text {
    font-size: 1.6rem;
    letter-spacing: 2px;
  }

  .tab-title {
    color: #E6E8EB;
    font-size: 1rem;
    letter-spacing: 0px;
  }

  .tabs-text {
    font-size: 1rem;
  }

  .card-btn {
    font-size: 1rem;
    letter-spacing: 0px;
  }
}
</style>